import * as React from 'react'
import {withRouter} from 'react-router'
import * as Styles from './HomeSearchBar.style'
import { reportClickEvent } from '@weike/operation-report'
import { RegisterElement } from '../../../../services/hotspotReport'
import { History } from 'history'

function HomeSearchBar(props: {history: History}) {

    const goneToSearchPage = React.useCallback(() => {
        reportClickEvent(RegisterElement.search_bar)
        props.history.push('/searchpage')
    }, [])

    return (
         <div className={Styles.searchBar} onClick={() => goneToSearchPage()}>
            <div className={Styles.searchBarContent}>
                <img className={Styles.searchIcon} src="https://static-cos.lycheer.net/picture/8173011_90d6dbdcafd02259dd339ba523319c85.jpg" alt="search"/>
                <p className={Styles.searchBarText}>搜索课程/专栏/直播间</p>
            </div>
        </div>
    )
}

export default withRouter(HomeSearchBar)



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeSearchBar/HomeSearchBar.tsx